// Mag de AI-interviewer deze vraag nú stellen?
//
// De interviewer krijgt zijn vragenlijst één keer mee bij het starten van de
// sessie; daarna bepaalt het model zelf de volgorde. De regels staan als
// `AskOnlyIf` bij de vraag, zodat het model ze kan volgen — maar een model dat
// dat één op de twintig keer negeert levert onverklaarbare datavervuiling op.
// Deze poort is de harde grens: hij zit vóór het opslaan, dus een vraag die
// niet gesteld had mogen worden levert geen document op.
//
// FAALT OPEN WAAR DAT MOET. Is de veldenlijst nog niet geladen, dan zou een
// dichte poort het hele interview blokkeren — dat is erger dan een antwoord te
// veel. Een verzonnen vraag-ID wordt wél tegengehouden: dat is geen
// zichtbaarheidskwestie maar een hallucinatie.
//
// AI-CONTEXT: See docs/features/conditional-questions.md

import filterFieldsForResponses from './filterFieldsForResponses'

/**
 * @param {object} args
 * @param {Array<object>} args.fields - De velden die op dit meetmoment gesteld
 *   kunnen worden (dus na filterFieldsForMoment)
 * @param {string} args.questionId - `QuestionnaireFields.ID` die het model wil opslaan
 * @param {Array<object>} args.answers - Wat de respondent tot nu toe antwoordde
 * @returns {boolean}
 */
const isQuestionAskable = ({ fields, questionId, answers } = {}) => {
    if (!Array.isArray(fields) || fields.length === 0) return true
    if (!questionId) return true

    return filterFieldsForResponses(fields, answers).some((field) => field?.ID === questionId)
}

export default isQuestionAskable
